"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Color = require("color");
var baseLValue = 21.247; // L-value of #333333
/**
 * Get dark mode color for a given color
 * @param color The color to calculate from
 */
function getDarkColor(color) {
    try {
        var computedColor = Color(color || undefined);
        var colorLab = computedColor.lab().array();
        var newLValue = (100 - colorLab[0]) * ((100 - baseLValue) / 100) + baseLValue;
        color = Color.lab(newLValue, colorLab[1], colorLab[2])
            .rgb()
            .alpha(computedColor.alpha())
            .toString();
    }
    catch (_a) { }
    return color;
}
exports.default = getDarkColor;
//# sourceMappingURL=getDarkColor.js.map